import i18next from 'i18next';
import { z } from 'zod';
import { vehiculeCheckTypeCheckPointSchema } from '@/schemas/vehicule-check-type-check-point/vehicule-check-type-check-point.schema';

export const vehiculeCheckTypeSchema = z.object({
  id: z.string().optional(),
  groupId: z
    .string()
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('common:groupRequired'),
        });
      }
    })
    .default(''),
  icon: z.string().nullish(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:nameRequired'),
      });
    }
  }),
  shortDescription: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('inspectionType:shortDescriptionRequired'),
      });
    }
  }),
  longDescription: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('inspectionType:longDescriptionRequired'),
      });
    }
  }),
  detectLicensePlateInVideo: z.boolean().default(false),
  personTypes: z.array(z.string()).nullish(),
  vehiculeCheckTypeCheckPoints: z
    .array(vehiculeCheckTypeCheckPointSchema)
    .nullish(),
  active: z.boolean().default(true),
});

export type TVehiculeCheckTypeSchema = z.infer<typeof vehiculeCheckTypeSchema>;
